function createPubSub () {
  /**
   * @typedef {Object} Topic
   * @property {Function[]} listeners
   * @property {any} value
   */
  /**
   * @type {{ [name: string]: Topic }}
   */
  const topics = {};

  function getOrAddTopic (topic) {
    if (!topics[topic]) {
      topics[topic] = {
        listeners: [],
        value: undefined,
      };
    }

    return topics[topic];
  }

  const pubSub = {
    pub: (topicName, value) => {
      const topic = getOrAddTopic(topicName);

      topic.value = value;
      topic.listeners.forEach(listener => listener(value));
    },
    sub: (topicName, handler) => {
      const topic = getOrAddTopic(topicName);
      topic.listeners.push(handler);

      return () => {
        const index = topic.listeners.indexOf(handler);
        topic.listeners.splice(index, 1);
      };
    },
    value: topicName => getOrAddTopic(topicName).value,
  };

  return pubSub;
}

if (typeof window !== 'undefined' && !window.reservamosPubSub) {
  window.reservamosPubSub = createPubSub();
}



// WEBPACK FOOTER //
// ./utils/pubSub.js